import React from 'react';
import LandingDemoConversation from './LandingDemoConversation';

const FULL_SESSION_TURNS = [
  {
    speaker: 'client',
    text: "I've been thinking about drinking less, but weekends are where it always slips.",
  },
  {
    speaker: 'clinician',
    text: 'Weekends are the place where your intention runs into the habit you have built.',
    chip: 'CR',
    chipClassName: 'anonymous-landing__demo-chip--cr',
  },
  {
    speaker: 'client',
    text: "Yeah, and once friends start pouring, I don't want to be the only one stopping early.",
  },
  {
    speaker: 'clinician',
    text: 'What do you notice about the nights when you do stop earlier than usual?',
    chip: 'Q',
    chipClassName: 'anonymous-landing__demo-chip--q',
  },
];

export default function FullSessionModalDemo() {
  return (
    <div className="anonymous-landing__demo anonymous-landing__demo--conversation-only">
      <LandingDemoConversation turns={FULL_SESSION_TURNS} avatarMode="feedback" />
    </div>
  );
}
